import * as Yup from "yup";

export const DatePickerSchema = Yup.object()
  .shape({
    day: Yup.number().required("Required"),
    month: Yup.number().required("Required"),
    year: Yup.number().required("Required")
  })
  .required();
